import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/core-js/modules/es.array.iterator.js";
import "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/core-js/modules/es.promise.js";
import "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/core-js/modules/es.object.assign.js";
import "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/core-js/modules/es.promise.finally.js";
import Vue from 'vue';
import '@/assets/styles/public.scss';
import '@/assets/layout/layout.scss';
import App from './app.vue';
import router from './router'; // @ts-ignore

import Loading from '@/plugins/Loading'; // @ts-ignore

import stat from '@vivo/v-stat'; // @ts-ignore

import Toast from '@/plugins/toast'; // @ts-ignore

import * as filters from '@/filters';
import * as context from '@/utils/context'; // import { ToolItem } from '@vivo/xcontrol-client/dist/global';
// vlog.init(H5_ID, PROJECT_ENV.BASE_URL, 'event_id');

Vue.use(Loading);
Vue.use(stat);
Vue.use(Toast);
Object.keys(filters).forEach(function (name) {
  // @ts-ignore
  Vue.filter(name, filters[name]);
});
Object.assign(Vue.prototype, context);
window.VMonitor && window.VMonitor.initVue(Vue);
Vue.config.productionTip = false; // if (PROJECT_ENV.ENV === 'dev' || PROJECT_ENV.ENV === 'test') {
//     // @ts-ignore
//     import('@vivo/xcontrol-client').then(({ default: loadXControl }: any) => {
//         const xcontrol = loadXControl({
//             list: [] as ToolItem[]
//         });
//         xcontrol.$on('clickItem', (item: ToolItem) => {
//             // 菜单点击
//         });
//     });
// }

new Vue({
  router: router,
  // store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app'); // 错误页，跳回首页

if (router.currentRoute.path.indexOf('/error') !== -1) {
  router.replace('/');
}